import React, { useEffect, useState, useCallback } from 'react';
import api, { formatRupiah } from '../../lib/api';

export default function DashTransactions() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const res = await api.get('/transactions/mine');
      setRows(res.data);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const badge = (s) => {
    const map = {
      completed: { bg: 'bg-secondary', label: 'Berhasil' },
      pending: { bg: 'bg-accent', label: 'Menunggu' },
      cancelled: { bg: 'bg-destructive text-white', label: 'Dibatalkan' },
    };
    const x = map[s] || map.pending;
    return <span className={`inline-block border-2 border-foreground px-2 py-0.5 text-xs font-bold uppercase ${x.bg}`}>{x.label}</span>;
  };

  return (
    <div className="space-y-6 pt-2 md:pt-0" data-testid="dash-transactions">

      <div className="border-2 border-foreground bg-white shadow-brutal-md overflow-hidden">
        {loading ? (
          <div className="p-8 text-center">Memuat...</div>
        ) : rows.length === 0 ? (
          <div className="p-10 text-center text-muted-foreground">Belum ada transaksi.</div>
        ) : (
          <div className="overflow-x-auto overflow-y-hidden">
            {/* Table for Desktop */}
            <table className="hidden md:table w-full text-sm">
              <thead className="bg-foreground text-background">
                <tr>
                  <th className="text-left p-3 font-bold uppercase tracking-wide text-xs">Supporter</th>
                  <th className="text-left p-3 font-bold uppercase tracking-wide text-xs">Unit</th>
                  <th className="text-right p-3 font-bold uppercase tracking-wide text-xs">Jumlah</th>
                  <th className="text-right p-3 font-bold uppercase tracking-wide text-xs">Net</th>
                  <th className="text-left p-3 font-bold uppercase tracking-wide text-xs">Status</th>
                  <th className="text-left p-3 font-bold uppercase tracking-wide text-xs">Waktu</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.order_id} className="border-t-2 border-foreground hover:bg-background">
                    <td className="p-3 font-medium">{r.supporter_name}</td>
                    <td className="p-3">{r.unit_emoji} {r.qty}× {r.unit_name}</td>
                    <td className="p-3 text-right font-bold">{formatRupiah(r.amount)}</td>
                    <td className="p-3 text-right font-bold text-primary">{formatRupiah(r.net_amount)}</td>
                    <td className="p-3">{badge(r.status)}</td>
                    <td className="p-3 text-xs text-muted-foreground">
                      {new Date(r.completed_at || r.created_at).toLocaleString('id-ID')}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Cards for Mobile */}
            <div className="md:hidden divide-y-2 divide-foreground/10">
              {rows.map((r) => (
                <div key={r.order_id} className="p-4 space-y-3">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <span className="text-xl">{r.unit_emoji}</span>
                      <span className="font-bold">{r.supporter_name}</span>
                    </div>
                    {badge(r.status)}
                  </div>
                  <div className="flex justify-between text-xs font-bold uppercase tracking-wider text-foreground/60">
                    <span>{r.qty}× {r.unit_name}</span>
                    <span>{new Date(r.completed_at || r.created_at).toLocaleDateString('id-ID')}</span>
                  </div>
                  <div className="flex justify-between items-end border-t border-foreground/5 pt-2">
                    <p className="text-[10px] uppercase font-black text-foreground/40 leading-none">Net Masuk</p>
                    <p className="text-lg font-display font-bold text-primary leading-none">{formatRupiah(r.net_amount)}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
